import { Card, Typography, Select, DatePicker, Button, Empty, Pagination } from "antd";
import { Input, Form } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SortingArrow from "../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import { changeLoader } from "../../redux/reducers/loader";
import { capitalizeName, formatDateFunction } from "../../utils/helper/utils";
import { debounce } from "lodash";
import { saveAs } from "file-saver";
import { addDeleteGetLocalStorage, storageKeys } from "../../utils/global/localData";
import { checkPermissionAction } from "../../utils/helper/utils";
import { jwtDecode } from "jwt-decode";
import { usePersistentFilters } from "../../Hooks/commonApiHooks/usePersistentFilters";

const selectStatus = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "settled",
    label: "Settled",
  },
  {
    value: "planned",
    label: "Planned",
  },
];
const DriverPayouts = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);

  const [permissionJson, setPermissionJson] = useState([]);
  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
      setPermissionJson(permissionJson);
    }
    if (!checkPermissionAction("Driver Payouts", permissionJson, "view")) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllDriverPayout = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_DRIVERS_PAYOUT.GET_ALL_DRIVERS_PAYOUT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllDriverPayout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const { Search } = Input;
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };
  const handleDateChange = (dates, dateStrings) => {
    const [startdate, enddate] = dateStrings; // Get the date strings from the RangePicker

    // Update the filter with the selected start and end dates
    setInputData((prevState) => ({
      ...prevState,
      periodStartDate: startdate, // Set the start date
      periodEndDate: enddate, // Set the end date
    }));
  };
  const handleSearchDebounced = debounce((value) => {
    form.setFieldValue("search", value);
    setInputData((prev) => ({ ...prev, search: value }));
    setPaginationModel((prev) => ({ ...prev, page: 1 }));
  }, 300); // Debounce delay in milliseconds (adjust as needed)

  const exportAllDriverPayout = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
      };
      let response = await globalRequest(Apis.MANAGE_DRIVERS_PAYOUT.EXPORT_ALL_DRIVERS_PAYOUT, "get", {}, { params: params }, true);
      if (response?.status === 200) {
        let apiResponse = response?.data;
        if (apiResponse?.data?.length === 0) {
          toast.error("No data found for export");
        } else {
          let exportData = [];

          for (let item of apiResponse.data) {
            exportData.push({
              'Sales Period': `${formatDateFunction(item.peroidStartDate)}-${formatDateFunction(item.peroidEndDate)}`,
              'Driver Name': item?.driver_name,
              'Expected Payout Date': item.expected_payout_date ? formatDateFunction(item.expected_payout_date) : "",
              'Actual Payout Date': item.actual_payout_date ? formatDateFunction(item.actual_payout_date) : "",
              'Expected Payout Amount': item.expected_payout_amnt,
              'Actual Payout Amount': item.actual_payout_amnt,
              'Status': item.status,
            });
          }

          const headers = Object.keys(exportData[0]).join(","); // Extract headers
          const rows = exportData.map((row) =>
            Object.values(row)
              .map((value) => `"${value}"`) // Escape values
              .join(",")
          );
          const csvContent = [headers, ...rows].join("\n");

          // Create a Blob and save file
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          saveAs(blob, "drivers_payout.csv");
        }
      } else {
        toast.error(response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  usePersistentFilters({
    form,
    location,
    currentPath: "/driver-payouts",
    addPath: "/driver-payouts-detail",
    editPathPrefix: "/driver-payouts-detail/",
    storageKey: "driver_payout",
    inputData,
    setInputData,
    paginationModel,
    setPaginationModel,
  });

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Driver Payouts
            </Typography>
          </div>
          <div>
            <RangePicker className="mx-1.5 cursor-pointer my-1 sm:my-0" onChange={handleDateChange} />
            <Select
              style={{
                width: 100,
              }}
              placeholder="Status"
              options={selectStatus}
              showSearch
              filterOption={(input, selectStatus) => (selectStatus?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              className="mx-1.5 cursor-pointer my-2 sm:my-0"
              value={form.getFieldValue("status")}
              onChange={(e) => {
                form.setFieldValue("status", e);
                setInputData((prev) => ({ ...prev, status: e }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            <Search
              placeholder="Search by Driver Name "
              onSearch={onSearch}
              style={{
                width: 250,
              }}
              className="mx-1.5 cursor-pointer my-2 sm:my-0"
              onChange={(e) => {
                const value = Validation.strFormat(e.target.value, "trim");
                handleSearchDebounced(value); // Debounced function
              }}
            />
            {checkPermissionAction("Driver Payouts", permissionJson, "export") ? (
              <Button type="primary" size={14} className="mx-1.5 cursor-pointer" onClick={exportAllDriverPayout}>
                Export
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap vertical-top">
                  Sales Period <SortingArrow onSort={(order) => handleSort("peroidStartDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Driver Name <SortingArrow onSort={(order) => handleSort("name", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Expected Payout Date <SortingArrow onSort={(order) => handleSort("expectedPayoutDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Actual Payout Date <SortingArrow onSort={(order) => handleSort("actualPayoutDate", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Expected Payout Amount <SortingArrow onSort={(order) => handleSort("expectedPayoutAmount", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Actual Payout Amount <SortingArrow onSort={(order) => handleSort("actualPayoutAmount", order)} />
                </th>
                <th scope="col" className="px-3 py-3 vertical-top whitespace-nowrap">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b text-gray-700" key={index} onClick={() => navigate("/driver-payouts-detail/" + item.id)}>
                    <td className="px-3 py-4 vertical-top font-semibold cursor-pointer whitespace-nowrap">
                      {formatDateFunction(item.peroidStartDate, "dd/mm/yyyy")} To {formatDateFunction(item.peroidEndDate, "dd/mm/yyyy")}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item.user.firstName} {item.user.lastName}
                    </td>
                    <td className="px-3 py-4 vertical-top">{formatDateFunction(item.expectedPayoutDate, "dd/mm/yyyy")}</td>
                    <td className="px-3 py-4 vertical-top">
                      {item.actualPayoutDate ? formatDateFunction(item.actualPayoutDate, "dd/mm/yyyy") : ""}
                    </td>
                    <td className="px-3 py-4 vertical-top">{item.expectedPayoutAmount.toFixed(2)}</td>
                    <td className="px-3 py-4 vertical-top">{item.actualPayoutAmount.toFixed(2)}</td>
                    <td className="px-3 py-4 vertical-top">
                      <span
                        className={`flex items-center ${
                          item.status === "planned" ? "bg-blue-50" : "bg-green-50"
                        } text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]`}
                      >
                        {capitalizeName(item.status)}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
              onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
            />
          </div>
        ) : null}
      </Card>
    </>
  );
};
export default DriverPayouts;
